import React from 'react';

const heartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18 1l-6 4-6-4-6 5v7l12 10 12-10v-7z"/></svg>
);
export default heartIcon;




// WEBPACK FOOTER //
// ./src/utils/icons/heart.icon.js